import { createStyles } from "@mantine/core"
import { mutateColorWhenLoggedInAsUser } from "@/components/TopNavigation/helpers"

export const useStyles = createStyles(
    (theme, { loggedInAsUser, popdownIsOpen }: { loggedInAsUser: boolean; popdownIsOpen: boolean }) => ({
        topBarIcon: {
            color: mutateColorWhenLoggedInAsUser("white", theme.colors.violet[8], {
                loggedInAsUser,
            }),

            ...(popdownIsOpen && {
                color: mutateColorWhenLoggedInAsUser(theme.colors.violet[7], theme.colors.violet[8], {
                    loggedInAsUser,
                }),
            }),
        },

        item: {
            color: theme.colors.gray[7],
            padding: "0.75rem 1rem",
            borderRadius: "0",
            transition: "background-color .3s ease-in-out",

            "&:hover": {
                backgroundColor: theme.colors.violet[1],
                color: theme.colors.violet[8],
            },
        },

        anchor: {
            textDecoration: "none !important",
        },

        icon: {
            color: theme.colors.violet[8],
            width: "0.875rem",
            height: "0.875rem",
            marginRight: ".75rem",
        },

        button: {
            width: "2.5rem",
            padding: "0px",
            backgroundColor: "transparent",
            border: "none",
            borderRadius: "2rem",

            "&:hover": {
                backgroundColor: theme.colors.violet[8],
                border: "none",
            },

            ...(loggedInAsUser && {
                "&:hover": {
                    backgroundColor: theme.colors.violet[3],
                    border: "none",
                },
            }),

            ...(popdownIsOpen && {
                "&:hover": {
                    backgroundColor: theme.colors.violet[1],
                    border: "none",
                },
            }),

            "&[data-expanded]": {
                boxShadow: "none",
                border: "none",
                backgroundColor: mutateColorWhenLoggedInAsUser(theme.colors.violet[8], theme.colors.violet[3], {
                    loggedInAsUser,
                }),
            },
            "&:active": {
                transform: "none",
            },
        },

        email: {
            minWidth: "15rem",
            color: theme.colors.gray[7],
            fontSize: "0.875rem",
            lineHeight: "150%",
            padding: "0.75rem 1rem",
        },

        divider: {
            marginBottom: "0.5rem",
        },

        logout: {
            color: theme.colors.red[9],
            padding: "0.75rem 1rem",
            borderRadius: "0",
            transition: "background-color .3s ease-in-out",

            "&:hover": {
                backgroundColor: theme.colors.red[0],
            },
        },

        logoutIcon: {
            marginRight: ".75rem",
        },

        dropdown: {
            padding: "0.25rem 0 .5rem",
            boxShadow: theme.shadows.xl,
        },
    }),
)
